import { Pipe, PipeTransform } from '@angular/core';

const roles = {
  dispatcher: $localize`Fleet Manager`,
  driver: $localize`Driver`,
  group: $localize`Group`,
};

@Pipe({ name: 'userRole' })
export class UserRolePipe implements PipeTransform {
  public transform(roleKey: string): string {
    return roles[roleKey];
  }
}
